<template>
  <MainCard>
    <div class="w-full max-w-md  rounded-xl  relative">
      <p class="text-sm text-gray-600 text-center mb-3" v-if="show">
        {{ $t("camera.description") }}
      </p>

      <div class="w-full relative animate-fade-in mt-5" v-if="showLabel">

        <div>
          <label class="block text-sm font-medium mb-0.5">
            {{ $t('photo.label') }}
          </label>
          <p class="text-xs text-gray-600 mb-2.5">
            {{ $t('photo.subtitle') }}
          </p>
        </div>


        <div class="w-full mt-5">
          <div @click="initCamera" class="text-sm w-fit rounded-lg font-bold px-5 py-2 text-center mx-auto transition duration-200 hover:cursor-pointer mb-3 
               bg-gradient-to-br from-cocacola-primary to-[#b1060c] text-white hover:bg-[#a32b45]">
            {{ $t('camera.open_button') }}
          </div>
        </div>
      </div>


      <div v-if="show" class="flex flex-col items-center gap-4">

        <div class="w-full max-w-sm bg-black rounded-xl overflow-hidden">
          <div class="relative w-full aspect-[4/5] bg-black   flex justify-center items-end ">
            <div
              class="absolute z-10 p-2 rounded-full bg-gradient-to-b from-cocacola-primary to-[#b1060c] text-white mb-3"
              @click="capture">

              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-7 h-w-7 ">
                <path
                  d="M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z" />
                <circle cx="12" cy="13" r="3" />
              </svg>
            </div>
            <video ref="video" autoplay playsinline
              class="absolute  rounded-xl  inset-0 w-full h-full object-cover border-2 border-cocacola-primary"></video>
          </div>
        </div>
      </div>

      <!-- <div class="text-center ">
      <p v-if="showRequestMessage" class="text-sm text-gray-500 mt-1">
        {{ $t("camera.permission_message") }}
      </p>
    </div> -->

      <transition name="fade" mode="out-in">
        <div v-if="!show && photo !== null"
          class="relative mt-4 flex flex-col items-center border-3 border-cocacola-primary shadow rounded-xl  bg-black w-full aspect-[4/5]">
          <div
            class="absolute bg-black/50 w-full h-full flex justify-center items-center border-3 border-cocacola-primary rounded-xl z-20">

            <div class="loader"></div>

          </div>

          <img :src="previewImage" class="w-full max-w-sm rounded-xl shadow" />


        </div>

      </transition>
    </div>
  </MainCard>
</template>

<script setup>
import MainCard from '@/components/mainCard.vue';
import { useParticipationStore } from '@/stores/useParticipationStore';
import { onMounted, ref, defineEmits, onUnmounted } from 'vue';
// import { getPusher } from "@/plugins/pusher";
import { useRouter } from 'vue-router';
import { useBroadcast } from '@/composables/useBroadcast';




const broadcastPlugin = useBroadcast();



const router = useRouter();
const participationStore = useParticipationStore();
const showLabel = ref(true);
const show = ref(false);
const video = ref(null);
const stream = ref(null);
const photo = ref(null);
const photoError = ref('');
const previewImage = ref(null);
const showRequestMessage = ref(true);
const emit = defineEmits(['toggleError', 'toggleBottleSuccess', 'togglePhotoAnalysis']);


onMounted(async () => {
  try {
    // listenForBroadCastAnalysis(); 
    // await initCamera();
    show.value = false;
  } catch (error) {
    console.log('error :>> ', error);
  }
})

const initCamera = async () => {
  showLabel.value = false;
  const perm = await checkPermission();

  showRequestMessage.value = true;

  if (!perm.supported) {
    alert("Camera not supported on this device/browser.");
    return;
  }
  console.log('### perm.supported :>> ',  perm.supported);

  try {
    show.value = true;

    stream.value = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: "environment" },
    });

    video.value.srcObject = stream.value;
    showRequestMessage.value = false;

  } catch (err) {
    show.value = false;
    console.log('err :>> ', err);

  }
};


const checkPermission = async () => {
  if (!navigator.mediaDevices?.getUserMedia) {
    return { supported: false };
  }

  try {
    const status = await navigator.permissions.query({ name: "camera" }).catch(() => null);

    if (!status) return { supported: true };

    return {
      supported: true,
      state: status.state,
    };
  } catch {
    return { supported: false };
  }
};



const capture = () => {

  const canvas = document.createElement("canvas");
  canvas.width = video.value.videoWidth;
  canvas.height = video.value.videoHeight;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(video.value, 0, 0);

  canvas.toBlob((blob) => {
    if (!blob) {
      console.error("Failed to capture image blob");
      return;
    }

    photo.value = blob;
    previewImage.value = URL.createObjectURL(blob);

    stopCamera();




    submitPhoto();

  }, "image/jpeg");
};

const stopCamera = () => {
  show.value = false;

  if (stream.value) {
    stream.value.getTracks().forEach((t) => t.stop());
  }
};

const handleRetry = () => {

  participationStore.form.photo = null;
  photo.value = null;
  show.value = true;

  initCamera();
};

const submitPhoto = async () => {
  if (!photo.value) return;

  const file = new File([photo.value], "bottlePhoto.jpg", { type: "image/jpeg" });
  participationStore.form.photo = file;
  participationStore.form.previewPhoto = previewImage.value;

  show.value = false;
  photoError.value = '';

  if (!participationStore.form.photo) {
    photoError.value = 'photo.error.noPhoto';
    handleRetry();
    emit('toggleError', photoError.value);
    return;
  }

  try {
    let response = await participationStore.submitPhoto();

    if (response.success) {

      if (response.already_has_valid_photo) {
        photo.value = null;

        toggleBottleSuccess(participationStore.participation?.brand ?? 'cocacola');
      } else {
        listenForBroadCastAnalysis();
        // listenForScanResult();
      }


      return;
    }

    const bottleErrorKeys = [
      "invalid_photo_content",
      "invalid_brand",
      "not_a_bottle",
      "cap_not_removed",
      "low_confidence_detection"
    ];

    if (bottleErrorKeys.includes(response.message)) {
      photoError.value = "photo.error.invalid_photo_content";
    } else {
      photoError.value = "photo.error." + response.message || "photo.error.photo_failed_to_upload";
    }

    handleRetry();
    emit('toggleError', photoError.value);

  } catch (err) {
    console.log('err :>> ', err);

    photoError.value = "photo.error.photo_failed_to_upload";
    handleRetry();
    emit('toggleError', photoError.value);
  }
};

const toggleBottleSuccess = () => {
  emit('toggleBottleSuccess', participationStore.participation?.brand ?? 'cocacola');
  router.push({ name: 'spin', params: { code: participationStore.link } });

}

const togglePhotoAnalysis = (show) => {
  emit('togglePhotoAnalysis', show);
}

// const listenForScanResult = () => {

//   togglePhotoAnalysis(true);
//   const pusher = getPusher();
//   const channelName = `photo-analysis-${participationStore.link}`;
//   const channel = pusher.subscribe(channelName);

//   // const callbackTest = (data) => {

//   //   let parsedData = data;
//   //   if (typeof data === 'string') {
//   //     try {
//   //       parsedData = JSON.parse(data);
//   //     } catch (e) {
//   //       console.error('Failed to parse data:', e);
//   //       return;
//   //     }
//   //   }

//   //   console.log('called the callback with data :>> ', parsedData.payload);
//   //   togglePhotoAnalysis(false);
//   //   if (parsedData.payload.success) {
//   //     toggleBottleSuccess();
//   //   } else {
//   //     photoError.value = "photo.error." + parsedData.payload.message;
//   //     emit("toggleError", photoError.value);
//   //     handleRetry();
//   //   }
//   // };



//   const callback = (data) => {
//     console.log('called the callback with data :>> ', data.payload);
//     togglePhotoAnalysis(false);
//     if (data.payload.success) {
//       toggleBottleSuccess();
//     } else {
//       photoError.value = "photo.error." + data.payload.message;
//       emit("toggleError", photoError.value);
//       handleRetry();
//     }
//   };
//   channel.bind("photo-analysis", callback);

//   onUnmounted(() => {
//     channel.unbind("photo-analysis", callback);
//     pusher.unsubscribe(channelName);
//   });
// };


const listenForBroadCastAnalysis = () => {
  togglePhotoAnalysis(true);

  const channelName = participationStore.link;
  const eventName = 'photo-analysis';

  broadcastPlugin.listen(channelName, eventName, broadcastCallback)


}

const broadcastCallback = (data) => {

  console.log('data :>> ', data);
  togglePhotoAnalysis(false);
  if (data.payload?.success) {
    participationStore.updateParticipationPhotoData(data.payload);
    toggleBottleSuccess();
  } else {
    photoError.value = "photo.error." + (data.message || data.payload?.message);
    emit("toggleError", photoError.value);
    handleRetry();
  }

  broadcastPlugin.stopListening();
}

onUnmounted(() => {
  broadcastPlugin?.stopListening();
});

</script>

<style scoped>
.loader {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>